import React from 'react'
import { getUrl } from '../../common/services/builders'

function AtoZItem({ entry }) {
    return (
        <a href={getUrl(entry)}>{entry.title}</a>
    )   
}

export default AtoZItem;